<template>
  <div id="app56">
    <Meeting/>
  </div>
</template>

<script>
import Meeting from '@/components/video-call/meeting-view/MeetingView.vue'
export default {
  name: 'MeetingDefault',
  components: {
    Meeting
  },
  beforeMount(){
      console.log("before mounting of it..")
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>